<template>
  <div>
    <h4>CHANNEL <span>by JOJOCHAT</span></h4>
    <iframe
      :src="`https://chat.jojonomic.com/jojonomic/channel/${JSON.parse(element.info).name}?layout=embedded`"
      class="discussion-widget-box"
    />
  </div>
</template>

<script>

export default {
  props: {
    element: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
    };
  },

  methods: {
  },
};
</script>



// WEBPACK FOOTER //
// src/views/widget/widget-card/jChannelWidget.vue